export const SHIPPING_METHODS = [
  {
    name: "Paczkomat Inpost",
    description: "",
    cost: 10,
    freeShipping: 100,
    slug: "paczkomat",
    methodId: "easypack_parcel_machines",
  },
  {
    name: "Kurier Inpost",
    description: "",
    cost: 14,
    freeShipping: 150,
    slug: "courier-inpost",
    methodId: "flat_rate",
  },
  {
    name: "Kurier DPD",
    description: "",
    cost: 14,
    freeShipping: 150,
    slug: "courier-dpd",
    methodId: "flat_rate",
  },
];

export const PAYMENT_METHODS = [
  {
    name: "Szybki przelew paynow",
    slug: "paynow",
    id: 0,
  },
  {
    name: "BLIK",
    slug: "blik",
    id: 2007,
  },
  {
    name: "Karta płatnicza",
    slug: "card",
    id: 2002,
  },
  {
    name: "Google Pay",
    slug: "google-pay",
    id: 2003,
  },
];
